const mbToBytes = (mb: number): number => {
  const BYTES_IN_KB = 1024

  return mb * Math.pow(BYTES_IN_KB, 2)
}

export { mbToBytes }
